<template lang="pug">
    b-container.pt-3
      h4 Staff
      b-card.my-3
        p Staff accounts
        content-loader(v-if="!staffAccounts", :height="7")
        b-table(v-else="", hover, :items="staffAccounts", :fields="fields", fixed)
          template(v-slot:cell(Delete)='row')
            b-button(size='sm', @click='deleteStaffAccount(row.item)') Delete
      b-link.text-primary(:to="{name: 'serviceCreateAccount'}")
        i.fa.fa-plus.mr-2
        span Create account
</template>

<script>
import { mapState, mapActions } from 'vuex';
import standardMix from '@/mixins/standardMix';

export default {
  name: 'StaffAccounts',
  components: {
  },
  mixins: [standardMix],
  data() {
    return {
      fields: [
        { key: 'firstname', label: 'Name', sortable: true },
        { key: 'lastname', label: 'Surname', sortable: true },
        { key: 'email', label: 'Email' },
        { key: 'phone', label: 'Phone' },
        { key: 'type', label: 'Level' },
        { key: 'type', label: 'Level' },
        { key: 'Delete', label: '' },
      ],
    };
  },
  computed: {
    ...mapState('account', ['staffAccounts']),
    ...mapState('alert', ['alert']),
    inputForm() {
      return {
      };
    },
  },
  methods: {
    ...mapActions('account', ['getStaffAccounts', 'deleteStaffAccount']),
    onSubmit(evt) {
      evt.preventDefault();
    },
  },
  created() {
    this.getStaffAccounts();
  },
};
</script>

<style lang="scss" scoped>
input:disabled {
    border: none !important;
    background: transparent;
    color: gray;
}
</style>



// WEBPACK FOOTER //
// src/components/views/Staff.vue